import { arrayRequired, labeled } from '../../util/joi';
import { schema as fundsAvailableSchema } from './HomeLoanFundsAvailable.schema';
import { schema as fundsRequiredSchema } from './HomeLoanFundsRequired.schema';

export const schema = (Joi: any, label: string) =>
  Joi.object().keys({
    fundsAvailable: arrayRequired(
      Joi,
      fundsAvailableSchema(Joi, labeled(label, 'Funds available -'))
    )
      .min(1)
      .label(labeled(label, 'Funds available -')),
    fundsRequired: arrayRequired(
      Joi,
      fundsRequiredSchema(Joi, labeled(label, 'Funds required -'))
    )
      .min(1)
      .label(labeled(label, 'Funds required -'))
  });

export default {
  schema
};
